import { render, staticRenderFns } from "./autoTest.vue?vue&type=template&id=7df65032&scoped=true&"
import script from "./autoTest.vue?vue&type=script&lang=js&"
export * from "./autoTest.vue?vue&type=script&lang=js&"
import style0 from "./autoTest.vue?vue&type=style&index=0&id=7df65032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df65032",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7df65032')) {
      api.createRecord('7df65032', component.options)
    } else {
      api.reload('7df65032', component.options)
    }
    module.hot.accept("./autoTest.vue?vue&type=template&id=7df65032&scoped=true&", function () {
      api.rerender('7df65032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/autoTest.vue"
export default component.exports